module.exports = __webpack_public_path__ + "img/yihuihua_wx.e46bb40b.png";